export function handleLocalStorageBool( old_value, value, parameter) {
    if (value) { // value === true
        return {
            action: "set",
            value: {
                ...old_value,
                [parameter]: value
            }
        }
    } else { // value === false
        if(old_value){ // if old_value = null nothing needs to be done
            delete old_value[parameter] // if (parameter===false) then doesn't need to be saved in local storage
            
            if (Object.keys(old_value).length) { // update local storage without [parameter]
                return {action: "set", value: old_value};
            } else { // empty object -> storageKey can be removed from local storage
                return {action: "remove", value: null};
            }
        }
        
    } 
}

export function handleInitialLocalStorageBool (old_value, parameter) {
    if (old_value && old_value[parameter]) {
        return old_value[parameter];
    }
    return false;
}